import * as React from "react";
const SvgModeComment = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v16h16l4 4z",
  fill: "currentColor"
}));
export default SvgModeComment;